module.exports = __webpack_public_path__ + "static/media/video-disney.333ea713.png";